import { useState, useEffect } from "react";

const STORAGE_KEY = "cookie-consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setMounted(true);
      // Small delay to trigger the slide-up animation
      const timer = setTimeout(() => setVisible(true), 50);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
    // Remove from DOM after animation completes
    setTimeout(() => setMounted(false), 400);
  };

  if (!mounted) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-transform duration-300 ease-out
        ${visible ? "translate-y-0" : "translate-y-full"}`}
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <div className="max-w-5xl mx-auto px-4 py-4 sm:px-6 sm:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="text-sm text-[#1B1B1B] font-outfit flex-1 leading-relaxed">
            We use cookies to improve your experience. By continuing, you agree to our{" "}
            <a
              href="/privacy-policy"
              className="text-[#FF7C53] underline underline-offset-2 hover:text-[#FB5B38] transition-colors"
            >
              Privacy Policy
            </a>
            .
          </p>
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={() => handleConsent("declined")}
              className="px-5 py-2 text-sm font-poppins text-[#8B8B8B] border border-gray-300 rounded-full
                hover:border-[#1B1B1B] hover:text-[#1B1B1B] transition-colors
                focus:outline-none focus:ring-2 focus:ring-[#FF7C53]/40"
            >
              Decline
            </button>
            <button
              onClick={() => handleConsent("accepted")}
              className="px-5 py-2 text-sm font-poppins text-white bg-[#FF7C53] rounded-full
                hover:bg-[#FB5B38] transition-colors
                focus:outline-none focus:ring-2 focus:ring-[#FF7C53]/40"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
